import "@/composables/useNotification";

const SafetyObservationForm = () =>
  import("../../components/safety_observation/ObservationForm.vue");
const SafetyObservationListing = () =>
  import("../../components/safety_observation/SafetyObservationListing.vue");
const SafetyObservationUpdateForm = () =>
  import("../../components/safety_observation/ObservationUpdate.vue");

const routes = [
  {
    path: "/ObservNow",
    component: SafetyObservationForm,
  },
  {
    path: "/raft/manage_researchers/raft_safety_observation",
    component: SafetyObservationListing,
    name: "observationListing",
  },
  {
    path: "/raft/manage_researchers/raft_safety_observation/:obv_id",
    component: SafetyObservationUpdateForm,
  },
];

const globalComponents = {};

export {
  routes as safetyObservationRoutes,
  globalComponents as safetyObservationGlobalComponents,
};
